import { connect } from 'react-redux';

import {
    clickOnViewEvent,
    clickOnSeeMore,
    clickOnOnboardingCard,
} from '../redux/events/actions';

import EventsBucket from '../components/EventsBucket';

const _mapStateToProps = (state) => ({
    isMobile: state.app.isMobile,
    isAuthenticated: state.user.isAuthenticated,
    searchCriteria: state.content.flatBucket
        ? state.content.flatBucket.eventSearch
        : { dates: ['current_future'] },
    locationSlug: state.location.slug,
    currentPlace: state.location.currentPlace,
    shouldShowOnboardingEntryPoint:
        state.app.featureFlags.shouldShowOnboardingEntryPoint,
    tabKey: state.content.browseState.tabKey,
    userId: state.user.publicId,
    seasonalContent: state.content.seasonal,
});

const _mapDispatchToProps = {
    onSeeMore: clickOnSeeMore,
    onViewEvent: clickOnViewEvent,
    onClickOnBoardingCard: clickOnOnboardingCard,
};

export default connect(_mapStateToProps, _mapDispatchToProps)(EventsBucket);
